// «Personalizza»: quali widget mostra la Dashboard. Un pannello sotto il pulsante, che si chiude
// con Esc o con un clic fuori.
import { useEffect, useRef, useState } from 'react';
import { Button } from '../../components/Button';
import { Switch } from '../../components/Switch';
import { WIDGETS } from './prefs';
import type { WidgetId } from './prefs';

export function Customize({
  hidden,
  onChange,
}: {
  hidden: WidgetId[];
  onChange: (hidden: WidgetId[]) => void;
}) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const away = (e: MouseEvent) => {
      if (box.current && !box.current.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', away);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', away);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);

  return (
    <div ref={box} style={{ position: 'relative' }}>
      <Button icon="settings" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        Personalizza
      </Button>
      {open && (
        <div role="dialog" aria-label="Widget della Dashboard" className="dash-customize">
          <div className="t-overline faint">Widget visibili</div>
          {WIDGETS.map((w) => (
            <Switch
              key={w.id}
              label={w.label}
              checked={!hidden.includes(w.id)}
              onChange={(on) => onChange(on ? hidden.filter((h) => h !== w.id) : [...hidden, w.id])}
            />
          ))}
        </div>
      )}
    </div>
  );
}
